import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

/* data imports */
import {
  pizzaPrepImagesObj,
  pastaPrepImagesObj,
  burgerPrepImagesObj,
  smoothiePrepImagesObj,
} from "../game-data/ingredientsImagesObj";

/* animation imports */
import { elementsEntryExit } from "../../assets/js/animations";

const PreparationArea = ({
  hoveredIngredient,
  dishType,
  selectedIngredients,
  calculateIsActive,
  dishIsPrepared,
}) => {
  const [selectedDishPrepObj, setSelectedDishPrepObj] = useState({});
  const [selectedDishPrepSuffix, setSelectedDishPrepSuffix] = useState("");
  const [selectedDishBase, setSelectedDishBase] = useState("");
  const [selectedDishPrepared, setSelectedDishPrepared] = useState("");

  useEffect(() => {
    if (dishType === "pizza") {
      setSelectedDishPrepObj(pizzaPrepImagesObj);
      setSelectedDishPrepSuffix("PizzaPrep");
      setSelectedDishBase("pizzaPlate");
      setSelectedDishPrepared("pizzaPrepared");
    } else if (dishType === "pasta") {
      setSelectedDishPrepObj(pastaPrepImagesObj);
      setSelectedDishPrepSuffix("PastaPrep");
      setSelectedDishBase("pastaPan");
      setSelectedDishPrepared("pastaPrepared");
    } else if (dishType === "burger") {
      setSelectedDishPrepObj(burgerPrepImagesObj);
      setSelectedDishPrepSuffix("BurgerPrep");
      setSelectedDishBase("burgerTray");
      setSelectedDishPrepared("burgerPrepared");
    } else if (dishType === "smoothie") {
      setSelectedDishPrepObj(smoothiePrepImagesObj);
      setSelectedDishPrepSuffix("SmoothiePrep");
      if (calculateIsActive) {
        setSelectedDishBase("smoothiePreparing");
      } else {
        setSelectedDishBase("smoothieJar");
      }
      setSelectedDishPrepared("smoothiePrepared");
    } else {
      setSelectedDishPrepObj({});
      setSelectedDishPrepSuffix("");
      setSelectedDishBase("");
      setSelectedDishPrepared("");
    }
  }, [dishType, calculateIsActive]);

  return (
    <div className="preparation-area">
      <div className="dish-type-base">
        <AnimatePresence>
          {selectedDishBase && (
            <motion.img
              layout
              src={selectedDishPrepObj[selectedDishBase]}
              alt="Dish Type Base"
              className={`${
                calculateIsActive && dishType === "pasta" ? "d-none" : ""
              }`}
              variants={elementsEntryExit}
              initial="initial"
              animate="animate"
              exit="exit"
            />
          )}
        </AnimatePresence>
      </div>
      {!calculateIsActive && (
        <div className="dish-type-ingredients">
          <AnimatePresence>
            {selectedIngredients.length > 0 &&
              selectedIngredients.map((item, i) => {
                return (
                  <motion.img
                    layout
                    key={i}
                    src={
                      selectedDishPrepObj[
                        `${item.imageLink}${selectedDishPrepSuffix}`
                      ]
                    }
                    alt={item.header}
                    variants={elementsEntryExit}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                  />
                );
              })}
          </AnimatePresence>
        </div>
      )}

      {dishIsPrepared ? (
        <div className="dish-type-final">
          <AnimatePresence>
            <motion.img
              src={selectedDishPrepObj[selectedDishPrepared]}
              alt="Prepared Dish"
              variants={elementsEntryExit}
              initial="initial"
              animate="animate"
              exit="exit"
            />
          </AnimatePresence>
        </div>
      ) : null}

      <div className="hovered-ingredient">{hoveredIngredient}</div>
    </div>
  );
};

export default PreparationArea;
